/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementRegistPasswordResponse } from "./UserManagementRegistPasswordResponse";

export type UserManagementRegistPasswordResponseApiRespoonse = {
  data?: UserManagementRegistPasswordResponse;
  status?: UserManagementRegistPasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementRegistPasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
